import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentProject,
  selectProjectByCode,
  setCurrentProject,
  selectDefaultProject,
} from "../../store/slices/projects";

export const useSyncProjectFromUrl = () => {
  const { projectCode } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentProject = useSelector(selectCurrentProject);
  const projectFromCode = useSelector((state) =>
    selectProjectByCode(state, projectCode)
  );
  const defaultProject = useSelector(selectDefaultProject);

  useEffect(() => {
    if (!projectCode) return;

    if (projectFromCode) {
      if (!currentProject || currentProject.id !== projectFromCode.id) {
        dispatch(setCurrentProject(projectFromCode));
      }
      return;
    }

    if (defaultProject) {
      const normCode = (defaultProject.code || "");
      const rest = window.location.pathname.split("/").slice(2).join("/") || "dashboard";
      navigate(`/${normCode}/${rest}`, { replace: true });
      return;
    }

  }, [projectCode, projectFromCode, currentProject, defaultProject, dispatch, navigate]);
};